import { motion } from "framer-motion";
import { SectionHeading } from "@/components/Reveal";
import { PROCESS_STEPS } from "@/data/content";

export const ProcessSection = () => {
  return (
    <section
      id="process"
      className="py-16 sm:py-20 lg:py-24 bg-card/40 border-y border-border"
      data-testid="process-section"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="How It Works"
          title="A process built around one conversation"
          description="You describe your business. We handle everything else — with total clarity at every step."
        />

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {PROCESS_STEPS.map((step, i) => (
            <motion.div
              key={step.step}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="card-highlight relative rounded-2xl bg-card/80 border border-border p-6 hover:border-primary/35 transition-colors duration-300"
              data-testid="process-step-card"
            >
              <span className="text-4xl font-semibold text-primary/25 font-mono-meta">
                {step.step}
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                {step.description}
              </p>
              {i < PROCESS_STEPS.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-5 h-px bg-primary/30" />
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
